import { Box, Flex, GridItem, Heading, Stack } from '@chakra-ui/react'

import { makeServerProps } from '@/server/query'

import makePage from '@/client/services/pages/makePage'

import ShwGrid from '@/components/Layout/ShwGrid'
import { useUserFromQuery } from '@/components/Profile/helpers'
import ProfileAchievementHighlights from '@/components/Profile/ProfileAchievementHighlights'
import ProfileActivityCalendar from '@/components/Profile/ProfileActivityCalendar'
import ProfileBadgesFull from '@/components/Profile/ProfileBadgesFull'
import ProfileLayout from '@/components/Profile/ProfileLayout'
import Card from '@/components/Worlds/UI/Card'

function ProfileAchievements(): JSX.Element {
  const { user } = useUserFromQuery()

  return (
    <ProfileLayout currentTab="Achievements">
      <ShwGrid>
        <GridItem colSpan={[12, 12, 6, 4]}>
          <Stack direction="column" spacing="32px">
            <Box>
              <Heading size="xl" mb="24px">
                Stats
              </Heading>
              <Card>
                <ProfileAchievementHighlights user={user} />
              </Card>
            </Box>
            <Box>
              <Heading size="xl" mb="24px">
                Activity
              </Heading>
              <Card>
                <Flex justify="center">
                  <ProfileActivityCalendar user={user} />
                </Flex>
              </Card>
            </Box>
          </Stack>
        </GridItem>
        <GridItem colSpan={[12, 12, 6, 8]}>
          <ProfileBadgesFull user={user} />
        </GridItem>
      </ShwGrid>
    </ProfileLayout>
  )
}

const ProfileAchievementsPage = makePage(ProfileAchievements, {
  onboardingUsers: 'allowed',
})
export const getServerSideProps = makeServerProps(ProfileAchievementsPage)
export default ProfileAchievementsPage
